/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';
import { WS_REQUEST_SAGA } from '../features/queues';
import { getCBXSocket } from '../web-socket/client';

// eslint-disable-next-line require-yield
function* sendWSRequest(action: any) {
  const socketClient = getCBXSocket();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { queueId, type, ...socketCmd } = action;
  const ts = (+new Date()).toString();
  socketCmd.requestId = queueId ? queueId.toString() : ts;

  if (queueId) {
    socketCmd.queueId = queueId;
  }

  socketClient.send({ ...socketCmd, boothId: socketClient.deviceUUID });
}

export function* wsRequestSaga() {
  yield takeLatest(WS_REQUEST_SAGA, sendWSRequest);
}
